import { render, staticRenderFns } from "./ProjectModalAddUsers.vue?vue&type=template&id=5fd88fba&"
import script from "./ProjectModalAddUsers.vue?vue&type=script&lang=js&"
export * from "./ProjectModalAddUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports